module.exports = __webpack_public_path__ + "img/unbreakable_vow.94df8ebf.jpg";